import { render, staticRenderFns } from "./CompanionServiceComponentModelInfo.vue?vue&type=template&id=1d8e1f1a&scoped=true&"
import script from "./CompanionServiceComponentModelInfo.vue?vue&type=script&lang=js&"
export * from "./CompanionServiceComponentModelInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompanionServiceComponentModelInfo.vue?vue&type=style&index=0&id=1d8e1f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8e1f1a",
  null
  
)

export default component.exports